import { useMemo } from 'react';
import { Location, Params, RouteObject, useLocation, useParams } from 'react-router-dom';

import { RouteConfig } from '@src/core/routing/types/route-config.interface';
import { BreadcrumbItem } from '@swo-react/breadcrumbs';
import { uniqBy } from 'lodash-es';
import { routeComponentFactory } from './route-component-factory';

export const useLocationChange = (): Promise<{
  location: Location;
  params: Readonly<Params<string>>;
}> => {
  const location = useLocation();
  const params = useParams();

  return useMemo(
    () =>
      Promise.resolve({
        location,
        params,
      }),
    [location, params]
  );
};

export type BreadcrumbRouteObject = RouteObject & {
  pathname: string;
  handle?: {
    breadcrumb?: string;
  };
};

export const createBreadcrumbsFromRouteMatches = (
  routeMatches: BreadcrumbRouteObject[]
): BreadcrumbItem[] => {
  const matchesWithBreadcrumbs = routeMatches.filter(
    (routeMatch) => routeMatch.handle?.breadcrumb && routeMatch.pathname
  );

  return uniqBy(matchesWithBreadcrumbs, 'pathname').map((match) => ({
    linkTo: match.pathname,
    title: match.handle?.breadcrumb,
  }));
};

export const buildEnhancedRoutes = (routes: RouteConfig[]) =>
  routes.map((route: RouteConfig) => routeComponentFactory(route));
